import React, {useMemo} from "react";
import {ConfigProvider, Tooltip} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import classnames from "classnames";
import {StringBuilder} from "../../AppUtils.js";
import "../../event/order-information-card.css";
import {calculatePackagePrice, calculatePriceWithoutVAT, calculateTotalPrice} from "./utils.jsx";
import {bidPricingInformationAdditionalInfo} from "./consts.js";

export const BidPricingInformation = ({bidInfo}) => {
    const packagePrice = useMemo(() => bidInfo?.price || calculatePackagePrice(bidInfo), [bidInfo]);
    const deliveryPrice = useMemo(() => bidInfo?.deliveryPrice || 0, [bidInfo?.deliveryPrice]);
    const totalPrice = useMemo(() => calculateTotalPrice(bidInfo), [bidInfo]);
    const hasAdditionalCharges = useMemo(() => deliveryPrice > 0, [deliveryPrice]);

    return (
        <div className="order-information-card-section order-information-card-bill-section">
            <div className="order-information-card-bill-section-title">
                <PriceLine
                    className={`${!hasAdditionalCharges ? " total-price" : ""}`}
                    label="מחיר הזמנה"
                    value={new StringBuilder(packagePrice?.toFixed(2)).append("₪ כולל מע״מ").toString()}
                />

                {!!deliveryPrice && (
                    <PriceLine
                        label="מחיר משלוח"
                        value={new StringBuilder(deliveryPrice.toFixed(2)).append("₪ כולל מע״מ").toString()}
                    />
                )}

                {hasAdditionalCharges ? (
                    <>
                        <PriceLine
                            className="total-price"
                            label="סה״כ"
                            value={new StringBuilder(totalPrice.toFixed(2)).append("₪ כולל מע״מ").toString()}
                        />

                        <PriceLine
                            className="total-price"
                            label="סה״כ (לא כולל מע״מ)"
                            value={new StringBuilder(calculatePriceWithoutVAT(totalPrice))
                                .append("₪ לא כולל מע״מ")
                                .toString()}
                        />
                    </>
                ) : null}
            </div>
            <div className="order-information-card-break-line" />
            {bidPricingInformationAdditionalInfo.map((info, index) => (
                <span className="order-information-card-additional-info-line" key={index}>
                    * {info}
                </span>
            ))}
            <div className="order-information-card-break-line" />
        </div>
    );
};

const PriceLine = ({className, titleClassName, label, value, tooltip}) => {
    return (
        <div className={classnames("order-information-card-price-line", className)}>
            <div>
                <span className={titleClassName}>{label}</span>
                {!!tooltip && (
                    <span>
                        <ConfigProvider direction={"rtl"}>
                            <Tooltip title={tooltip}>
                                <InfoCircleOutlined />
                            </Tooltip>
                        </ConfigProvider>
                    </span>
                )}
            </div>
            <div>{value}</div>
        </div>
    );
};
